import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaAndroid, FaApple, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpeg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import logo_icon from '../assets/logo_icon.png';
import app_screen from '../assets/app_screen.png';
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";
import OneHotelFeed from "./OneHotelFeed";

export default function HomeBanner3(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-primary"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-6 mb-5">
							<h6
								style={{
									fontSize: "52px",
									marginBottom: "40px"
								}}
								className="font-light"
							>
								Get Now Our Modern, User-Friendly Mobile App
							</h6>

							<h6
								style={{
									fontSize: "24px",
								}}
								className="font-light"
							>
								<MdCheck/> Simplified Booking
							</h6>

							<h6
								style={{
									fontSize: "24px",
								}}
								className="font-light"
							>
								<MdCheck/> Real-time Notifications
							</h6>

							<h6
								style={{
									fontSize: "24px",
								}}
								className="font-light"
							>
								<MdCheck/> Customized Offers
							</h6>

							<h6
								style={{
									fontSize: "24px",
								}}
								className="font-light"
							>
								<MdCheck/> Booking History
							</h6>


							<div
								className="row"
							>
								<div className="col-md-12 mt-5">
									<h6
										style={{
											fontSize: "16px",
										}}
										className="font-bold text-dark"
									>
										Click the buttons below to download for either iPhone or Android Devices
									</h6>
								</div>

								<div className="col-md-6 mt-3 mb-3">
									<button
										className="btn btn-block btn-padded btn-rounded btn-dark"
									>
										<FaAndroid size={32}/> Android
									</button>
								</div>

								<div className="col-md-6 mt-3 mb-3">
									<button
										className="btn btn-block btn-padded btn-rounded btn-dark"
									>
										<FaApple size={32}/> iPhone
									</button>
								</div>

								<div className="col-md-12 mt-3 mb-3">
									<button
										className="btn btn-block btn-padded btn-rounded btn-secondary"
										onClick={() => {
											window.open("https://avanhotels.com/app/", "_blank");
										}}
									>
										<FaGlobe size={32}/> Or Just Use Our WEB APP
									</button>
								</div>
							</div>
						</div>

						<div className="col-md-6 mb-5">
							<div
								style={{
									width: "300px",
									height: "auto",
									margin: "0 auto",
									padding: "5px",
									borderRadius: "20px"
								}}
								className="mShadow1 bg-surface"
							>
								<img
									src={app_screen}
									style={{
										height: "auto",
										width: "100%",
										borderRadius: "20px"
									}}
								/>
							</div>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}